<template>
    <div class="search-input form-group input-with-icon">
        <a-icon icon="Loupe" />

        <input
            v-model.trim="inputLocal"
            type="text"
            class="form-control"
            :id="name"
            :placeholder="placeholder"
            :disabled="inactive"
        />

        <a-icon
            v-if="inputLocal"
            @click.native="inputLocal = ''"
            class="form-group-close"
            icon="Close"
        />

        <a-icon
            v-else-if="tooltip || searchParamsTooltip"
            class="form-group-close"
            icon="Info"
            v-tooltip="tooltip || searchParamsTooltipText"
        />
    </div>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
    props: {
        placeholder: {
            type: String,
            default: 'Szukaj...'
        },
        name: {
            type: String,
            required: false
        },
        searchInput: {
            type: String,
            default: ''
        },
        inactive: {
            type: Boolean,
            required: false
        },
        tooltip: {
            type: String,
            required: false
        },
        searchParamsTooltip: {
            type: Array,
            require: false
        }
    },
    computed: {
        inputLocal: {
            get() {
                return this.searchInput.trim()
            },
            set(value) {
                const sanitizedValue = DOMPurify.sanitize(value)
                this.$emit('change', sanitizedValue)
            }
        },
        searchParamsTooltipText() {
            if (!this.searchParamsTooltip?.length) return

            let html = `
                <p class="text-left mb-0 font-weight-bold">Możesz wyszukać po:</p>
                <ul class="text-left">
            `
            this.searchParamsTooltip.forEach(el => {
                html += `<li>${el}</li>`
            })
            html += '</ul>'

            return html
        }
    }
}
</script>

<style lang="scss">
.search-input {
    .form-control {
        padding-right: 2rem;
        font-size: inherit !important;
    }

    .form-group-close {
        --size: 16px;
        width: var(--size);
        height: var(--size);
    }
}
</style>
